<template>
  <button
    class="btn btn-secondary btn-sm"
    :title="$t(`imageUpload.uploadImage`)"
    v-on:click="$refs.file.click()"
    :class="{ 'loading-spin spin-dark': loadBtn }"
    :disabled="loadBtn"
  >
    <span>
      <BaseIcon name="gallery" color="var(--black)" />
    </span>
  </button>
  <input type="file" ref="file" v-on:change="upload" class="visually-hidden" />
  <ConfirmModal
    ref="replaceModal"
    :title="$t(`imageUpload.replaceTitle`)"
    :text="$t(`imageUpload.replaceText`)"
    :ok-button="$t(`imageUpload.replaceButton`)"
    :cancel-button="$t(`imageUpload.replaceCancelButton`)"
    v-on:success="confirmReplace"
    v-on:cancel="cancelReplace"
  />
</template>

<script>
import http from "../../modules/http";
import BaseIcon from "../icons/BaseIcon";
import tenant from "../../modules/tenant";
import ConfirmModal from "../modals/ConfirmModal.vue";
import store from "../../store/index";

export default {
  name: "ImageUpload",
  components: { BaseIcon, ConfirmModal },
  props: {
    id: Number,
    type: String,
    name: String,
    private: Boolean,
  },
  computed: {
    mediaUrl() {
      return tenant.getAppMediaUrl();
    },
  },
  emits: ["update"],
  data: function () {
    return {
      loadBtn: false,
      pendingFile: null,
      pendingFilename: null,
    };
  },
  methods: {
    filename(file) {
      return this.name
        ? this.name + "." + file.name.split(".").pop()
        : file.name;
    },
    upload() {
      const file = this.$refs.file.files[0];
      if (!file) {
        return;
      }
      const filename = this.filename(file);
      // Reset so picking the same file again re-triggers this handler.
      this.$refs.file.value = "";

      this.loadBtn = true;

      const send = {
        type: this.type,
        id: this.id,
        images: [filename],
      };

      http
        .fetch("/files/check-duplicates", send)
        .then((data) => {
          this.loadBtn = false;
          if (data?.duplicates?.length > 0) {
            this.pendingFile = file;
            this.pendingFilename = filename;
            this.$refs.replaceModal.showModal();
          } else {
            this.doUpload(file, filename);
          }
        })
        .catch(() => {
          this.loadBtn = false;
        });
    },
    confirmReplace() {
      if (this.pendingFile) {
        this.doUpload(this.pendingFile, this.pendingFilename);
        this.pendingFile = null;
        this.pendingFilename = null;
      }
    },
    cancelReplace() {
      // No upload, the current image stays. Explain it to the user.
      store.commit("setApiError", {
        title: this.$t("imageUpload.uploadCancelled"),
        message: this.$t("imageUpload.duplicateKept"),
      });
      this.pendingFile = null;
      this.pendingFilename = null;
    },
    doUpload(file, filename) {
      this.loadBtn = true;

      const request = new XMLHttpRequest();
      const _this = this;

      let send = {
        type: this.type,
        id: this.id,
        images: [filename],
      };
      if (_this.isVariant) {
        send.is_variant = true;
      }

      http.fetch("/files/upload", send).then((data) => {
        const formData = new FormData();
        formData.append("image", file, filename);
        formData.append("token", data.token);
        formData.append("album", this.id);
        formData.append("category", this.type);

        request.open(
          "POST",
          process.env.VUE_APP_MEDIA_API +
            "/" +
            tenant.getTenantName() +
            (_this.private ? "/files/upload" : "/images/upload")
        );

        request.onload = function () {
          if (request.status >= 200 && request.status < 300) {
            let data2 = JSON.parse(request.responseText);
            _this.loadBtn = false;
            _this.$emit("update", data2.operation.images[0]);
          } else {
            console.log("oh no");
            _this.loadBtn = false;
          }
        };

        request.send(formData);
      });
    },
  },
};
</script>
